const Subtitle = ({ text, color } ) => {
    return(
    <p className={`mobile:max-w-80 small:max-w-64 desktop:max-w-full 
        mobile:text-[16px] small:text-[17px] desktop:text-2xl 
        text-center bg-opacity-50 
        ${color === "red" ? "text-red" : "text-darkerGreen"}`} dangerouslySetInnerHTML={{ __html: text }} />
    )
}

export default Subtitle;